/** Obsah v cestine. Nazvy rezimu sleduji katalog `cs.json`. */
import type { LanguageContent } from '../registry.js';

export const CS: LanguageContent = {
  home: {
    intro: [
      'Retusch je online kreslicí hra pro 2 až 10 hráčů, hraje se v prohlížeči, bez instalace a bez účtu. Každé kolo dostanete obraz, ze kterého byla vymazána jedna oblast: přemalujte ji tak, aby v díle zmizela. Pak se role obrátí a je třeba vypátrat retuše ostatních.',
      'Skoro všechny kreslicí hry odměňují toho, koho poznají nejdřív. Retusch žádá pravý opak: vyhrává ten, koho nikdo neuvidí.',
    ],
    steps: [
      {
        title: 'Obraz s dírou',
        text: 'Dostanete ilustraci, ze které byla vymazána jedna oblast.',
        painting: '1_airIsland',
        stage: 'masked',
      },
      {
        title: 'Přemalujete ji',
        text: 'Oblast dokreslíte tak, aby splynula s dílem.',
        painting: '1_airIsland',
        stage: 'painted',
      },
      {
        title: 'Lov',
        text: 'Obraz se vrátí s retušemi všech: najděte je dřív než ostatní.',
        painting: '1_airIsland',
        stage: 'hunt',
      },
      {
        title: 'Odhalení',
        text: 'Každá skrýš vyjde najevo a body padnou.',
        painting: '1_airIsland',
        stage: 'reveal',
      },
    ],
    modes: [
      {
        name: 'Společný lov',
        text: 'Všichni malují do stejného obrazu, každý do své oblasti. Pak se lov otevře pro všechny naráz: retuš se najde jen jednou, tím, kdo ji zahlédne první. Je to výchozí režim, ten, ve kterém se pořád něco děje.',
      },
      {
        name: 'Stream',
        text: 'Hostitel nekreslí: hledá sám, zatímco všichni ostatní se schovávají v jeho obraze. Vymyšleno pro živé vysílání, kde je lov tou podívanou. Zdarma navždy.',
      },
      {
        name: 'Každý svůj obraz',
        text: 'Jedno dílo na hráče. Hledáte retuš jediného člověka, na jediné kliknutí. Nejjednodušší pravidlo hry, a to nejnapínavější.',
      },
      {
        name: 'Kreslí jen jeden',
        text: 'Jedno kolo, jeden kreslíř, všichni ostatní v honičce. Role se střídá a kreslíř sleduje, jak jeho skrýš padne, nebo vydrží.',
      },
      {
        name: 'Battle royale',
        text: 'Stejný lov, ale první odhalená retuš vyřazuje svého autora. Hraje se do posledního zbylého a nepočítá se jediný bod.',
      },
      {
        name: 'Soutěž',
        text: 'Nikdo nehledá. Všichni přemalují stejnou oblast stejného obrazu a pak každý hlasuje pro retuš, která se mu líbí nejvíc. Každý získaný hlas je bod.',
      },
    ],
    faq: [
      {
        question: 'Kolik hráčů je potřeba?',
        answer:
          'Od 2 do 10. Když jste sami, volné místo obsadí automatický protihráč, aby hra začala hned. Od čtyř výš ukáže společný lov to nejlepší.',
      },
      {
        question: 'Je to zdarma?',
        answer:
          'Ano. Rychlá hra, společný lov i režim stream jsou zdarma, bez časového limitu a bez omezení počtu her. Ostatní režimy jsou zatím také zdarma.',
      },
      {
        question: 'Potřebuji účet?',
        answer:
          'Ne. Napíšete jméno, kliknete, hrajete. Účet jen podrží jméno a avatar z jedné hry do druhé: zůstává nepovinný.',
      },
      {
        question: 'Funguje to na telefonu?',
        answer:
          'Ano, rozhraní se přizpůsobí dotyku: složená lišta nástrojů, lupa pod prstem, dvojí ťuknutí pro přiblížení. Přesto se kreslí přesněji myší a na velké obrazovce.',
      },
      {
        question: 'Jak pozvu kamarády?',
        answer:
          'Vytvoříte místnost, zkopírujete odkaz na pozvánku a vložíte ho, kam chcete. Kamarádi přistanou rovnou u stolu, bez účtu a bez instalace.',
      },
      {
        question: 'Co je to „retuš“?',
        answer:
          'To, co namalujete do vymazané oblasti. Když se povede, projde jako kus původního obrazu a nikdo ji nenajde. Když se nepovede, bije do očí.',
      },
    ],
    headings: {
      intro: 'Kreslicí hra, ve které je třeba zmizet',
      steps: 'Jak se to hraje',
      modes: 'Šest způsobů hry',
      faq: 'Časté otázky',
      more: 'Kam dál',
    },
    links: {
      rules: 'Přečtěte si celá pravidla a bodování',
      modes: 'Porovnejte režimy podrobně',
    },
  },

  howToPlay: {
    title: 'Jak hrát Retusch',
    summary:
      'Úplná pravidla hry Retusch: průběh kola, bodování na obou stranách, kreslicí nástroje a rady, jak se schovat a jak hledat.',
    sections: [
      {
        heading: 'Nápad ve třech větách',
        blocks: [
          'Dostanete obraz, ze kterého byla vymazána jedna oblast, a přemalujete ji tak, aby prošla bez povšimnutí.',
          'Pak si všichni prohlížejí retušované obrazy a hledají přemalované oblasti.',
          'Body získáváte rychlým nalezením, a získáváte je i po celou dobu, kdy vaše skrýš vydrží.',
        ],
      },
      {
        heading: 'Průběh kola',
        blocks: [
          'Hra řetězí stejná kola, ve výchozím nastavení pět. Každé projde třemi okamžiky.',
          {
            list: [
              'Kreslení. Dostanete svůj obraz a svou oblast a máte ve výchozím nastavení 2 minuty na to ji přemalovat. Tlačítko Hotovo znamená odevzdání: jakmile odevzdají všichni, kolo pokračuje, aniž by čekalo na časomíru.',
              'Lov. Obraz se objeví znovu i s retušemi a máte ve výchozím nastavení 30 sekund na to je najít. Kliknutí na přemalovanou oblast ji odhalí celému stolu.',
              'Odhalení. Všechny skrýše se orámují a pojmenují, i ty, které nikdo nenašel. Posuvník dovolí porovnat retušovaný obraz s původním dílem.',
            ],
          },
        ],
      },
      {
        heading: 'Bodování',
        blocks: [
          'Souběžně běží dvě počítadla a stojí proti sobě: kdo hledá, chce být rychlý; kdo kreslil, chce, aby jeho oblast vydržela.',
          {
            list: [
              'Pro hledajícího: 1000 bodů, pokud najdete během prvních 3 sekund, pak plynulý pokles až na 100 bodů na konci fáze. Chyba ani nenalezení nedávají nic.',
              'Pro kreslíře: jen 100 bodů, pokud vaše oblast padne hned, pak plynulý růst až na 800 bodů, pokud vydrží do konce. Retuš, kterou nikdo nenajde, má maximum, 800 bodů.',
            ],
          },
          'Kreslíř je zaplacen jen jednou, při odhalení, a podle nejrychlejšího hledajícího. Nezáleží tedy na tom, jestli vás hledají dva lidé, nebo osm: rozhoduje jen ten, kdo vás najde první.',
          'Bodování je stejné, ať nastavíte fázi jakkoli dlouhou. Prodloužení lovu neposune oba krajní body, jen sklon mezi nimi.',
          'Jedna jediná chyba za kolo. První kliknutí, které netrefí žádnou retuš, váš lov ukončí: bez tohoto pravidla by se obrázek prohrabával nazdařbůh, dokud se náhodou netrefí. Dvě gesta nestojí nic: kliknutí na vlastní oblast a kliknutí na už nalezenou retuš.',
        ],
      },
      {
        heading: 'Kreslicí nástroje',
        blocks: [
          {
            list: [
              'Štětec (B): tři rychlé velikosti a posuvník pro přesnou velikost. Zkratky 1, 2 a 3 volí tři velikosti.',
              'Plechovka (P): naráz vyplní plochu jednolitou barvou a nikdy nevyjde z vaší oblasti.',
              'Kapátko (I): nabere barvu kdekoli v obraze. Podržení klávesy Alt na ně přepne na jedno kliknutí a pak vrátí předchozí nástroj.',
              'Ruka (H): posune pohled. Mimo vaši oblast dělají štětec i plechovka totéž, takže nástroj skoro nikdy měnit nemusíte.',
              'Zpět (Ctrl+Z nebo Cmd+Z): vrací po jednom tahu, až třicetkrát. Krok vpřed neexistuje.',
              'Barva pozadí na konci palety: je to výchozí barva vaší oblasti. Malovat s ní znamená mazat, s tím rozdílem, že je to tah jako každý jiný, který lze vrátit i přemalovat. Proto ve hře není guma.',
            ],
          },
        ],
      },
      {
        heading: 'Pět rad, jak se schovat',
        blocks: [
          {
            list: [
              'Barvy nabírejte kapátkem, nehádejte je. Kapátko dá přesnou barvu okolí: plocha jen trochu vedle je vidět na dálku, kdežto přesná zmizí.',
              'Prodlužte to, co vaši oblast protíná. Zeď, obzor, větev, která vstupuje z jedné strany, musí z druhé vyjít přesně na svém místě. Přerušená čára je první stopa, kterou zkušený hráč hledá.',
              'Malujte nejdřív rohy. Je to nejčastější chyba: střed je vypiplaný, čtyři rohy zůstaly na výchozím pozadí a čtverec je vidět pouhým okem, aniž byste se na kresbu vůbec podívali.',
              'Postupujte od celku k detailu. Nejdřív položte velké barevné plochy tlustým štětcem, teprve pak dolaďujte. Opačně strávíte veškerý čas jedním rohem, zatímco zbytek zůstane prázdný.',
              'Napodobte míru detailu okolí. Příliš čistá oblast uprostřed nabité scény je vidět stejně dobře jako odbytá oblast uprostřed jednolité plochy.',
            ],
          },
        ],
      },
      {
        heading: 'Čtyři rady, jak hledat',
        blocks: [
          {
            list: [
              'Hledejte čáry, které se přeruší. Hrana, kabel, roh stolu, který se posune o vlásek: skoro vždycky je to tam.',
              'Nejdřív přehled, pak přiblížení. V celkovém pohledu vypadá špatně splynulá oblast jako skvrna. Přiblížení slouží k potvrzení, ne k hledání.',
              'Nedůvěřujte tomu, co je příliš hladké. Dokonale rovnoměrná plocha uprostřed textury je stejně podezřelá jako odbytý flek.',
              'Neklikejte nazdařbůh. Máte nárok na jednu jedinou chybu: lepší ztratit tři sekundy kontrolou než celé kolo.',
            ],
          },
        ],
      },
      {
        heading: 'A co podle režimu?',
        blocks: [
          'Všechno výše popisuje společný lov, tedy výchozí režim. Ostatní režimy mění, kdo kreslí, kdo hledá a jak se vyhrává: podrobnosti ke každému jsou na stránce herních režimů.',
        ],
      },
    ],
  },

  modes: {
    title: 'Herní režimy hry Retusch',
    summary:
      'Šest způsobů, jak hrát Retusch: společný lov, stream, každý svůj obraz, kreslí jen jeden, battle royale a soutěž. Průběh, doporučený počet hráčů a délka.',
    sections: [
      {
        heading: 'Společný lov',
        blocks: [
          'Výchozí režim, a ten, kterým se vyplatí začít.',
          'Všichni kreslí do stejného obrazu, každý do své oblasti. Když jsou retuše odevzdané, dílo se vrátí celé a lov se otevře pro všechny naráz. Retuš se najde jen jednou, tím, kdo ji zahlédne první: objeví se pak celému stolu a vypadne ze hry. Svou vlastní nenajdete nikdy a skrýš, kterou nikdo nezahlédne, dá svému autorovi maximum.',
          'Ideální pro velkou skupinu: nejsou žádné hluché chvíle, všichni hledají naráz a každý nález se objeví na obrazovce všech.',
          'Doporučeno: 3 až 10 hráčů.',
        ],
      },
      {
        heading: 'Stream',
        blocks: [
          'Zrcadlový obraz režimu „kreslí jen jeden“, vymyšlený pro živé vysílání.',
          'Všichni hráči kreslí do stejného obrazu kromě hostitele. Pak hledá jediný hostitel, zatímco jeho diváci sledují, jak se trápí. Nezískává body a nefiguruje ve výsledcích: hra se hraje mezi těmi, kdo se schovávají, on lov vede. Může se splést, kolikrát chce, pravidlo jediné chyby pro něj neplatí.',
          'Ideální pro večer ve vysílání, a to z jednoho konkrétního důvodu: protože hostitel nekreslí, diváci nikdy nevidí vznikat jeho skrýš. V ostatních režimech ho sledují, jak maluje svou oblast, a lov pro ně už žádné tajemství nemá.',
          'Doporučeno: 4 až 10 hráčů. Zdarma, a zůstane to tak.',
        ],
      },
      {
        heading: 'Každý svůj obraz',
        blocks: [
          'Každý hráč dostane své dílo a schová do něj svou retuš. Při lovu vám je předán obraz jediného dalšího člověka a máte jediné kliknutí na to ukázat přemalovanou oblast. Žádný závod, žádná konkurence: jen vy, jeden obraz a jedno rozhodnutí.',
          'Ideální ve dvou, nebo když chcete klidnou hru, kde má každý svůj čas.',
          'Doporučeno: 2 až 10 hráčů.',
        ],
      },
      {
        heading: 'Kreslí jen jeden',
        blocks: [
          'Jedno kolo, jeden kreslíř, všichni ostatní v honičce.',
          'V každém kole dostane obraz jediný člověk. Ostatní čekají a pak hledají jeho retuš, každý hodnocený podle svého času. Kreslíř je hodnocen podle nejrychlejšího hledajícího a znovu vidí svou skrýš, zmrazenou, zatímco ji ostatní hledají. Role se střídá: nastavení počtu kol tu počítá celé kruhy, protože hra je spravedlivá jen tehdy, když každý kreslil stejněkrát.',
          'Ideální pro malou skupinu, která se chce poměřit za stejných podmínek, kresbu po kresbě.',
          'Doporučeno: 3 až 6 hráčů, nad tento počet je čekání dlouhé.',
        ],
      },
      {
        heading: 'Battle royale',
        blocks: [
          'Společný lov s jedním vyřazením za kolo.',
          'Stejný sdílený obraz, stejný souběžný lov. Tady se ale nepočítá jediný bod: jediná otázka zní, kdo zbude. Hráč, jehož retuš je odhalena první, hru opouští. Ostatní hledají dál až do konce kola, což už nikoho nevyřadí, ale dá každému jeho pořadí, ukázané na jeho oblasti. Když není nalezen nikdo, nikdo nevypadne.',
          'Ideální na zakončení večera: napětí stoupá, jak se stůl vyprazdňuje, a poslední kolo se hraje ve dvou.',
          'Doporučeno: 4 až 10 hráčů.',
        ],
      },
      {
        heading: 'Soutěž',
        blocks: [
          'Jediný režim, ve kterém nikdo nehledá.',
          'Všichni přemalují stejnou oblast stejného obrazu. Pak si každý svým tempem prohlédne retuše ostatních a hlasuje pro tu, která se mu zdá nejpovedenější. Každý získaný hlas je bod pro svého autora. Během hlasování jsou autoři anonymní a pro sebe hlasovat nelze: jména a hlasy vyjdou najevo až při odhalení.',
          'Ideální, když je skupina různorodá, nebo když někdo raději kreslí bez tlaku lovecké časomíry.',
          'Doporučeno: 3 až 10 hráčů.',
        ],
      },
    ],
  },
  modeTable: [
    { name: 'Společný lov', players: '3 až 10', duration: '15-20 min' },
    { name: 'Stream', players: '4 až 10', duration: '15-20 min' },
    { name: 'Každý svůj obraz', players: '2 až 10', duration: '15-20 min' },
    { name: 'Kreslí jen jeden', players: '3 až 6', duration: '20-35 min' },
    { name: 'Battle royale', players: '4 až 10', duration: '20-30 min' },
    { name: 'Soutěž', players: '3 až 10', duration: '10-15 min' },
  ],
  modeTableHeadings: ['Režim', 'Hráči', 'Délka'],
  premium: {
    heading: 'Režimy zdarma a placené režimy',
    blocks: [
      'Společný lov a režim stream jsou zdarma, natrvalo.',
      'Zbylé čtyři budou placené při VYTVOŘENÍ hry, a jedině tam. Připojit se zůstane vždy zdarma: stačí, aby hru odemkl jediný člověk u stolu, a všichni si mohou zahrát všechny režimy, bez účtu a bez placení.',
      'Odemčení bude jednorázový nákup bez předplatného a odstraní i reklamy pro účet, který ho provedl. Zatím jsou všechny režimy otevřené všem.',
    ],
  },

  blog: [
    {
      slug: 'quest-ce-que-retusch',
      title: 'Co je Retusch?',
      date: '2026-08-21',
      summary:
        'Online kreslicí hra pro více lidí, formou blízká Gartic Phone, ale její mechanika připomíná spíš Meccha Chameleon: místo abyste se nechali poznat, snažíte se zmizet.',
      sections: [
        {
          heading: 'Kreslicí hra, ve které být poznán znamená prohrát',
          blocks: [
            'Retusch je online kreslicí hra pro 2 až 10 hráčů. Každé kolo dostanete ilustraci, ze které byla vymazána jedna oblast, a musíte ji přemalovat tak, aby splynula s dílem. Pak si všichni prohlížejí retušované obrazy a hledají přemalované oblasti.',
            'To, co ji odlišuje, se vejde do jedné věty: vyhrává ten, koho nikdo neuvidí.',
          ],
        },
        {
          heading: 'Co má společného s Gartic Phone',
          blocks: [
            'Forma je stejná: otevřete odkaz, napíšete jméno, hrajete. Žádný účet, žádná instalace, žádný klient ke stažení. Hra běží v prohlížeči a partie začíná během několika sekund. Kamarády pozvete vložením odkazu do konverzace a stůl se zaplní.',
            'Známé je i tempo: krátká kola, časomíra, fáze kreslení a pak fáze, kdy se ukáže, co vyrobili ostatní. A především to společné odhalení na konci kola, kdy všichni komentují, co vidí. Je to stejná skupinová radost.',
            'Stejně jako u Gartic Phone není potřeba umět kreslit. Dobře položená oblast oblohy porazí mistrovské dílo, které přetéká.',
          ],
        },
        {
          heading: 'Co si bere z Meccha Chameleon',
          blocks: [
            'V jádru je ale mechanika jinde. V Meccha Chameleon, trojrozměrné hře na Steamu, si nabarvíte vlastní postavu a pak ji umístíte do scény v naději, že ji nikdo nerozezná od okolí. Vítězství plyne z podobnosti a dobrého umístění, ne z akce.',
            'Retusch tento nápad přebírá a vrací ho do obrazu. Nevybíráte si, kam se schováte, oblast vám dá hra; zato celé to, co do ní přijde, vyrábíte sami. Skrýš se povede, když po ní pohled sklouzne a nezastaví se.',
            'A jako v každé hře na mimikry plyne napětí z dvojí role. Jste zároveň schovaní i lovci: zatímco pátráte v obraze po podezřelé ploše, někdo pátrá ve vašem.',
          ],
        },
        {
          heading: 'Co nikde jinde není',
          blocks: [
            'Bodování odměňuje obě strany opačně. Kdo hledá, získá tím víc, čím dřív najde; kdo kreslil, získá tím víc, čím déle jeho oblast vydrží. Retuš, kterou nikdo nezahlédne, dá svému autorovi maximum.',
            'Rodí se z toho velmi zvláštní způsob hry: nesnažíte se udělat to hezky, snažíte se to udělat přesně. Nabrat správnou barvu, prodloužit čáru přesně tam, kde má být, nenechat žádný roh prázdný. Jsou to gesta pozorování dřív než gesta kreslení.',
            'Nejjednodušší, jak to pochopit v praxi, je přečíst si celá pravidla, nebo spustit rychlou hru: začíná bez nastavování a bez čekání.',
          ],
        },
      ],
    },
    {
      slug: 'comment-etre-imbattable',
      title: 'Jak být v Retusch neporazitelní',
      date: '2026-08-21',
      summary:
        'Klávesové zkratky, postup od celku k detailu a chyba prázdných rohů: tři věci, které dělí začátečníka od hráče, kterého už nikdo nenajde.',
      sections: [
        {
          heading: 'Naučte se zkratky a zdvojnásobíte užitečný čas',
          blocks: [
            'Dvě minuty kreslení utečou hrozně rychle, když se pro každý nástroj chodí myší. Zkratky snadno získají dvacet nebo třicet sekund za kolo, a přesně ty sekundy věnujete detailům.',
            {
              list: [
                'B pro štětec, P pro plechovku, I pro kapátko, H pro ruku.',
                '1, 2 a 3 pro tři velikosti štětce, bez chození do lišty nástrojů.',
                'Ctrl+Z, na Macu Cmd+Z, pro vrácení po jednom tahu.',
                'Podržení klávesy Alt přepne na kapátko a vrátí předchozí nástroj, jakmile ji pustíte. Ze všech je nejužitečnější: naberete barvu za běhu a nástroj přitom vůbec neměníte.',
              ],
            },
            'Poznámka ke klávesnicím AZERTY: klávesy 1, 2 a 3 fungují i bez Shiftu, i když je na vaší klávesnici napsáno &, é a ". Hra čte polohu klávesy, ne znak, který vytváří.',
          ],
        },
        {
          heading: 'Malujte od celku k detailu',
          blocks: [
            'Klasická začátečnická chyba je začít v jednom rohu a vypiplat ho. Časomíra doběhne, tři čtvrtiny oblasti jsou pořád pozadí a retuš je vidět na deset metrů.',
            'Správný postup je opačný. Začněte tlustým štětcem, nebo plechovkou, a položte velké barevné plochy: oblohu, zeď, stín na zemi. Za dvacet sekund má vaše oblast správný celkový dojem a už se nečte jako cizí blok.',
            'Teprve pak zmenšete velikost a věnujte se přechodům: čáře obzoru, která protíná, hraně předmětu, přechodu, který se mění v půli výšky. Když nebude čas, ztratíte detail, ne kolo.',
            'Barvy vždycky nabírejte kapátkem místo výběru z palety. Přibližný odstín stačí k prozrazení celé oblasti, kdežto přesný odstín ji učiní neviditelnou.',
          ],
        },
        {
          heading: 'Nikdy nenechávejte prázdné rohy',
          blocks: [
            'Je to stopa číslo jedna a první, kterou zkušení hráči hledají. Oblast s pěkně zpracovaným středem, ale se čtyřmi rohy ponechanými na barvě pozadí, kreslí na obrazovce dokonalý obdélník. Není třeba se ani dívat na kresbu: geometrický tvar bije do očí.',
            'Zvykněte si zpracovat nejdřív okraj a teprve pak střed. Dobře splynulý rám odpustí přibližný vnitřek; obráceně to neplatí nikdy.',
            'Přetahujte přes okraje schválně. Hra váš tah na hranici oblasti ořízne, takže neriskujete nic, když půjdete výrazně dál, a je to jediný způsob, jak si být jistí, že v rohu nepřežije žádný pixel pozadí.',
          ],
        },
        {
          heading: 'A když jste na řadě s hledáním',
          blocks: [
            'Nejdřív přejeďte celý obraz bez přiblížení: špatně splynulá oblast vypadá jako skvrna a přiblížení slouží jen k potvrzení. Pak sledujte dlouhé čáry, ty, které protínají obraz: hrana posunutá o vlásek je skoro vždycky retuš.',
            'A pamatujte, že máte nárok na jednu jedinou chybu za kolo. Tři sekundy ověřování stojí míň než celé kolo.',
          ],
        },
      ],
    },
    {
      slug: 'jeu-de-dessin-entre-amis',
      title: 'Kreslicí hra na večer s přáteli',
      date: '2026-08-21',
      summary:
        'Proč Retusch funguje dobře v malé skupině, jak zvát vložením odkazu a proč stačí jediný hráč k odemčení placených režimů pro celý stůl.',
      sections: [
        {
          heading: 'Hra, která po nikom nic nechce',
          blocks: [
            'Největší překážkou herního večera na dálku je instalace. Účet k založení, klient ke stažení, verze, která nesedí: půlka skupiny to vzdá dřív, než se hraje.',
            'Retusch běží v prohlížeči. Kamarádi kliknou na odkaz, napíšou jméno a ocitnou se u stolu. Není co instalovat, není co zakládat, a funguje to dobře na počítači i na telefonu.',
            'Ještě něco se ve skupině počítá: nikdo nezůstane stranou proto, že neumí kreslit. Hra nežádá, abyste něco zobrazili, jen abyste oblast srovnali s tím, co ji obklopuje. Kdo kreslí špatně, ale dobře pozoruje, vyhrává často.',
          ],
        },
        {
          heading: 'Zvaní v praxi',
          blocks: [
            'Vytvořte místnost z úvodní obrazovky. Odškrtněte „veřejná místnost“, pokud chcete zůstat mezi sebou: pozvánka odkazem se pak stane jedinou cestou dovnitř.',
            'Zkopírujte odkaz příslušným tlačítkem a vložte ho do vašeho skupinového chatu, na váš hlasový kanál nebo do vaší zprávy. Obsahuje kód místnosti: kamarádi přistanou rovnou u vašeho stolu.',
            'Hru můžete nastavovat, zatímco se lidé scházejí: režim, počet kol, čas na kreslení, velikost oblasti i kategorie obrázků. Nic není dané, dokud nespustíte.',
          ],
        },
        {
          heading: 'Jeden platí, hrají všichni',
          blocks: [
            'Dva režimy jsou zdarma navždy: společný lov, tedy ten výchozí, a režim stream.',
            'Ostatní budou placené, ale jen při VYTVOŘENÍ hry. Připojit se zůstane zdarma, bez podmínek. V praxi stačí, aby hru odemkl jediný člověk ze skupiny, a celý stůl si užije všech režimů, bez účtu a bez placení.',
            'Odemčení je jednorázový nákup, bez předplatného.',
          ],
        },
        {
          heading: 'Který režim pro jakou skupinu',
          blocks: [
            'Ve třech nebo čtyřech stačí společný lov a pochopí se za jedno kolo. Od šesti výš je opravdu dobrý: nálezy se řetězí a obrazovka se nepřestává hýbat.',
            'Na zakončení večera zkuste battle royale: stůl se kolo za kolem vyprazdňuje a poslední se hraje ve dvou. Pro různorodou skupinu, kde někdo raději kreslí v klidu, sundá soutěž veškerý tlak lovecké časomíry.',
          ],
        },
      ],
    },
    {
      slug: 'jeu-de-dessin-en-stream',
      title: 'Kreslicí hra do živého vysílání',
      date: '2026-08-21',
      summary:
        'Retusch má režim vymyšlený pro živé vysílání, ve kterém streamer hledá sám, zatímco jeho diváci se schovávají. Jak ho použít a které další režimy fungují před publikem.',
      sections: [
        {
          heading: 'Režim ušitý na míru',
          blocks: [
            'Režim stream obrací role. Všichni hráči kreslí do stejného obrazu kromě hostitele, který nekreslí vůbec. Pak hledá jediný hostitel, zatímco jeho diváci sledují.',
            'Přesně tuhle situaci živé vysílání potřebuje, a to z jednoho konkrétního důvodu: protože hostitel nekreslí, jeho skrýš neexistuje a chat neviděl nic, co vidět neměl. Diváci naopak znají skrýše ostatních hráčů a mohou ho sledovat, jak kolem nich třikrát po sobě projde.',
            'Pro tento případ byla napsána dvě pravidla. Streamer nezískává body a nefiguruje ve výsledcích: hra se hraje mezi těmi, kdo se schovávají, on vede podívanou. A může se splést, kolikrát chce, zatímco všechny ostatní režimy se zastaví u první chyby. Živé vysílání nemůže skončit jedním nešťastným kliknutím.',
            'Režim stream je zdarma a zůstane to tak.',
          ],
        },
        {
          heading: 'Soutěž, druhý dobrý nápad',
          blocks: [
            'V režimu soutěž všichni přemalují stejnou oblast stejného obrazu a pak každý hlasuje pro retuš, která se mu líbí nejvíc. Není co hledat, jen co posoudit.',
            'Před publikem funguje výborně, a ze stejného důvodu jako režim stream: není co hledat, takže není co by chat pokazil. Návrhy se porovnávají vedle sebe, hlasování dá chvíli napětí a odhalení jmen nabídne jasnou tečku. Je to zároveň nejkratší režim.',
          ],
        },
        {
          heading: 'A ostatní režimy',
          blocks: [
            'Nic nenutí hrát jen ten určený režim, ale pak se vyplatí hrát s přáteli, a ne s chatem. Ve všech ostatních režimech streamer maluje svou oblast na obrazovce: diváci ji vidí vznikat a znají odpověď dřív, než lov vůbec začne.',
            'Hra mezi přáteli se naopak zvenčí sleduje výborně: fáze kreslení ukazuje, jak si každý staví svou skrýš, a odhalení odkryje všechny oblasti naráz, se jménem autora.',
          ],
        },
        {
          heading: 'Jak vtáhnout chat do hry',
          blocks: [
            'Odkaz na pozvánku je jediné, co je třeba sdílet. Vložte ho do chatu a první příchozí zaplní stůl: žádný účet k založení, žádné stahování, žádná fronta.',
            'Limit hráčů se nastavuje v místnosti, mezi 2 a 10. Při početném publiku otevřete raději několik krátkých her než jednu dlouhou: kolo trvá méně než tři minuty.',
          ],
        },
      ],
    },
    {
      slug: 'nouveautes',
      title: 'Novinky v Retusch',
      date: '2026-08-21',
      summary:
        'Herní změny v Retusch, od nejnovější po nejstarší: nové režimy, nová pravidla, vylepšení kreslení a lovu.',
      sections: [
        {
          heading: 'Srpen 2026',
          blocks: [
            {
              list: [
                'Oblast k přemalování už nezačíná bílým čtvercem, ale převládající barvou toho, co zakrývá. Nepřijdete už o polovinu času přemalováváním pozadí, které v obraze neexistuje.',
                'Plechovka už nenechává světlý lem podél tahů: nově se podsune pod jejich rozostřený okraj.',
                'Battle royale už nepočítá body. První odhalený hráč hru opouští a každý dostane pořadí v kole, ukázané na jeho oblasti, od červené po zelenou.',
                'Režim stream dává streamerovi tolik pokusů, kolik chce: první chyba už kolo neukončí.',
                'V režimu diváka lze nově posouvat a přibližovat obraz, jehož vznik sledujete.',
                'Emoji reakce vylétají od jména svého autora v seznamu hráčů, místo aby stoupaly ze spodního okraje obrazovky.',
                'Mimo oblast k přemalování posouvají štětec i plechovka pohled: pro pohyb už není třeba brát nástroj ruka.',
                'Název hry vlevo nahoře během partie vede po potvrzení zpět na úvodní stránku.',
                'K patnácti dostupným jazykům přibývá japonština a korejština.',
              ],
            },
          ],
        },
        {
          heading: 'Červenec 2026',
          blocks: [
            {
              list: [
                'Nový režim soutěž: všichni přemalují stejnou oblast a pak každý hlasuje pro retuš, která se mu líbí nejvíc.',
                'Nový režim stream, vymyšlený pro živé vysílání: hostitel hledá sám, zatímco jeho diváci se schovávají.',
                'Kategorie obrázků nahrazují úrovně obtížnosti. Zaškrtnete, co chcete vidět, a každá kategorie ukazuje ukázkový obraz.',
                'Dvě kola po sobě už nepadnou na stejný obraz a zaškrtnuté kategorie se z kola na kolo střídají.',
                'Galerie na konci hry dovolí přehrát si retuš tah po tahu a vyexportovat ji jako obrázek nebo jako animovaný GIF.',
              ],
            },
          ],
        },
      ],
    },
  ],

  ui: {
    atAGlance: 'Ve zkratce',
    allArticles: 'Všechny články',
    theRules: 'Pravidla hry',
    theModes: 'Herní režimy',
  },
};
